import { FuelAccordionItem, FuelTag, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import useSecurityAnalysisEvents from 'hooks/events/useSecurityAnalysisEvents';
import React from 'react';
import { IItem } from './types';

const Item: React.FC<IItem> = ({
  sectionName,
  accordionItemId,
  accordionLabel,
  status,
  tagColor,
  contentText,
  data,
  eventName,
}) => {
  const { emmitEvents } = useSecurityAnalysisEvents();

  return (
    <FuelAccordionItem
      label={accordionLabel}
      accordionId={accordionItemId}
      hasDivider
      onClick={(event) => emmitEvents(eventName, data, status, event)}
      data-testid={`${sectionName}-accordion`}
    >
      <FuelTag
        label={status}
        uppercase
        color={tagColor}
        highlight
        shape="rectangle"
        slot="tag"
        data-testid={`${sectionName}-status`}
      />
      <div slot="content">
        <FuelFlex defaultProps={{ flexDirection: 'column', gap: 'km6', padding: 'km4' }}>
          <FuelTypography size="body-md" weight="bold" color="neutral-default" data-testid="accordion-title">
            Como validamos
          </FuelTypography>
          <FuelTypography size="body-md" weight="medium" color="neutral-strong">
            {contentText}
          </FuelTypography>
        </FuelFlex>
      </div>
    </FuelAccordionItem>
  );
};

export default Item;
